import { render, staticRenderFns } from "./CompRankingContainer.vue?vue&type=template&id=f2284744&scoped=true"
import script from "./CompRankingContainer.vue?vue&type=script&lang=js"
export * from "./CompRankingContainer.vue?vue&type=script&lang=js"
import style0 from "./CompRankingContainer.vue?vue&type=style&index=0&id=f2284744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2284744",
  null
  
)

export default component.exports